import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import MenuDrawer from '../sidebar/menuDrawer';
import Logout from './Logout';
import { generateEmployeeImgUrl, getFullName, useWindowWide } from '../../utils/common_functions';
import {
  DownArrow,
  SunfocusLogo,
  MenuIcon,
  ToogleSidebarIcon,
  NotificationIconNew,
  SunfocusLogoSmall,
  HistoryIcon,
  SunfocusLogoAdmin,
  SunfocusLogoSmallAdmin
} from '../../theme/SvgIcons';
import {
  NavBoxStyle,
  AvatarBox,
  IconButtonStyle,
  MenuBox,
  ChipWrapper,
  ToogleLogo,
  Heading
} from './style';
import { appRoutes } from '../../routes/path';
import { updateActivityDrawer, updateSidebar } from '../../redux/sidebar/SidebarSlice';
import AvatarImage from '../common/AvatarImage';
import { Drawer, Typography, Popover } from 'antd';
import NotificationDrawer from './NotificationDrawer';
import ConfirmationModal from '../Modal/ConfirmationModal';
import { toast } from 'react-toastify';
import { logout } from '../../redux/globalAction';
import { hmsTabEnum, loginUserRole } from '../../utils/constant';
import styled from '@emotion/styled';
import { logoutUrl } from '../../redux/sign-in/apiRoute';

function NavBar() {
  const [notificationDrawer, setNotificationDrawer] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const largeScreen = useWindowWide(750);
  const anotherLargeScreen = useWindowWide(950);
  const [currentTab, setCurrentTab] = useState('');
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isSidebarOpen = useSelector((state) => state?.sidebar?.isSidebarOpen);
  const userDetails = useSelector((state) => state?.userInfo?.data?.user_details);
  const {
    isEmployee,
    loggedUserType,
    role = {},
    deviceId
  } = useSelector((state) => state?.userInfo);
  const hmsTab = useSelector((state) => state?.HmsSlice?.HmsTab);
  const [logoutPopoverOpen, setLogoutPopoverOpen] = useState(false);

  const routeHeadings = [...appRoutes];

  const handleLogout = async () => {
    setDeleteLoading(true);
    try {
      let res = await logoutUrl({
        deviceId: deviceId
      });

      if (res?.statusCode === 200) {
        dispatch(logout());
        toast.success('Logout Successfully');
        navigate('/');
      } else {
        toast.error(res?.message);
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleOpenMenu = () => setOpenMenu(!openMenu);

  const shouldShowHistoryIcon = () => {
    if (role?.role !== loginUserRole?.SUPERADMIN) return false;
    const path = location?.pathname;

    const includesPath = [
      'employee',
      'project',
      'clients',
      'roles',
      'sub-admin',
      'lms',
      'billingIds',
      'leads',
      ...(hmsTab !== hmsTabEnum?.ASSIGNEE ? ['hms'] : [])
    ];

    if (includesPath.some((include) => path?.includes(include)) && !path?.includes('collection')) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    const current = routeHeadings?.find((route) => location?.pathname.includes(route?.path))?.name;
    setCurrentTab(current);
    if (openMenu) setOpenMenu(false);
  }, [location.pathname]);

  function getLogo({ isSidebarOpen, largeScreen, isEmployee }) {
    if (isSidebarOpen && largeScreen) {
      return isEmployee ? <SunfocusLogo /> : <SunfocusLogoAdmin />;
    }
    return isEmployee ? <SunfocusLogoSmall /> : <SunfocusLogoSmallAdmin />;
  }

  return (
    <NavBoxStyle>
      {openLogoutModal && (
        <ConfirmationModal
          open={openLogoutModal}
          onCancel={() => setOpenLogoutModal(false)}
          title="Logout"
          onSubmit={handleLogout}
          buttonName="Yes"
          description="Are you sure you want to logout this account?"
          iconBG="#FB4A49"
          loading={deleteLoading}
        />
      )}
      {notificationDrawer && (
        <Drawer
          width={490}
          title="Notifications"
          placement="right"
          closable
          prefixCls="activityCustomDrawer"
          onClose={() => setNotificationDrawer(false)}
          open={notificationDrawer}
          key="right">
          <NotificationDrawer close={() => setNotificationDrawer(false)} />
        </Drawer>
      )}
      <FlexWrapper>
        <AvatarBox
          isSidebarOpen={isSidebarOpen}
          style={{
            width: isSidebarOpen && largeScreen ? '192px' : '33px',
            marginRight: !largeScreen && 0
          }}>
          {getLogo({ isSidebarOpen, largeScreen, isEmployee })}
          {largeScreen && (
            <ToogleLogo
              isSidebarOpen={isSidebarOpen}
              onClick={() => dispatch(updateSidebar(!isSidebarOpen))}>
              <ToogleSidebarIcon />
            </ToogleLogo>
          )}
        </AvatarBox>
        {!largeScreen && currentTab?.length > 20 ? (
          <Heading style={{ fontSize: '12px' }}>{currentTab}</Heading>
        ) : (
          <Heading>{currentTab}</Heading>
        )}
      </FlexWrapper>

      <FlexWrapper gap="12px">
        {largeScreen ? (
          <Popover
            arrow={false}
            open={logoutPopoverOpen}
            onOpenChange={setLogoutPopoverOpen}
            content={
              <Logout
                setOpenLogoutModal={setOpenLogoutModal}
                loggedUser={userDetails?.id}
                setIsLogoutOpen={() => {}}
                closePopover={() => setLogoutPopoverOpen(false)}
              />
            }
            trigger="click"
            placement="bottomRight"
            overlayStyle={{ minWidth: 200 }}>
            <MenuBox>
              <AvatarImage
                style={{ height: '40px', width: '40px', fontSize: '18px' }}
                image={generateEmployeeImgUrl(userDetails?.id)}
                name={isEmployee ? userDetails?.first_name : loggedUserType?.name}
              />
              <ChipWrapper>
                {anotherLargeScreen && (
                  <>
                    <Typography style={{ fontSize: '14px', fontWeight: '500' }}>
                      {isEmployee
                        ? getFullName(
                            userDetails?.first_name,
                            userDetails?.middle_name,
                            userDetails?.last_name
                          )
                        : loggedUserType?.name}
                    </Typography>
                  </>
                )}
              </ChipWrapper>
              <DownArrow />
            </MenuBox>
          </Popover>
        ) : (
          <div onClick={handleOpenMenu}>
            <MenuIcon />
          </div>
        )}
        {isEmployee && (
          <IconButtonStyle onClick={() => setNotificationDrawer(true)}>
            <NotificationIconNew />
          </IconButtonStyle>
        )}
        {shouldShowHistoryIcon() && (
          <div onClick={() => dispatch(updateActivityDrawer(true))}>
            <IconButtonStyle>
              <HistoryIcon />
            </IconButtonStyle>
          </div>
        )}
      </FlexWrapper>
      {!largeScreen && openMenu && (
        <Drawer
          width={490}
          title={
            isEmployee
              ? getFullName(
                  userDetails?.first_name,
                  userDetails?.middle_name,
                  userDetails?.last_name
                )
              : loggedUserType?.name
          }
          placement="right"
          closable
          prefixCls="activityCustomDrawer"
          open={openMenu}
          onClose={() => setOpenMenu(false)}
          key="right">
          <MenuDrawer />
        </Drawer>
      )}
    </NavBoxStyle>
  );
}

export default NavBar;

const FlexWrapper = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction || 'row'};
  align-items: ${({ align }) => align || 'center'};
  gap: ${({ gap }) => gap || '0'};
  position: ${({ position }) => position || 'relative'};
`;
